export default __webpack_public_path__ + "static/media/lp-video-1.ce4edabb.mp4";